/**
 * @file 本文件实现了分离器指令，该指令可以将DOM元素从组
 * 件原有的渲染位置移到`document.body`下，以修正`zIndex`
 * 层级显示问题。
 */

let target = document.body

export default {
  inserted (el, binding, vnode) {
    if (el.parentNode !== target) {
      el.__parentNode = el.parentNode
      target.appendChild(el)
    }
  },
  componentUpdated (el, binding) {
    if (el.parentNode !== target) {
      el.__parentNode = el.parentNode
      target.appendChild(el)
    }
  },
  unbind: function unbind (el, binding) {
    el.__parentNode.appendChild(el)
    el.__parentNode = null
  }
}



// WEBPACK FOOTER //
// ./src/directives/detacher.js